import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { SectionsService } from '../../../../services/sections.service';
import { PAGE_CONSTANTS, PAGE_AVAILABLE_ACTIONS } from '../../../../shared/constants/page.constants';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';
import { AuthorizeButtonDirective } from '../../../../shared/authorization/authorizeButton.directive';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';

@Component({
  selector: 'ppl-authorizations-list',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent, AuthorizeButtonDirective],
  templateUrl: './authorizations-list.component.html',
  styleUrl: './authorizations-list.component.css',
})
export class AuthorizationsListComponent implements OnInit {
  pageId: string = PAGE_CONSTANTS.AUTHORIZATION_DATA_GRID_PAGE;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any = [];
  lazyLoad = true;
  isPageRestrictionLoaded = false;
  @Input() isReadOnly = false;

  constructor(
    private router: Router,
    private sectionsService: SectionsService,
    private claimsService: ClaimsService,
    private userService: UserService,
    private authorizationService: AuthorizationsDetailsService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit() {
    this.sectionsService.setFlow('authorizations');
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  onAddAuthorizations() {
    if (this.isReadOnly) return;
    this.router.navigate(['/home/addAuthorizations']);
  }

  onViewSpendingPlans() {
    this.router.navigate(['/home/spendingPlans']);
  }

  cloneAuthorization(event: any) {
    if (this.isReadOnly) return;
    const selectedAuthorization = event.selectedCheckBox[0];
    this.authorizationService.setClonedAuthorization(selectedAuthorization);
    this.onAddAuthorizations();
  }

  rowClicked(rowDetail: any) {
    this.claimsService.clearAuthData();
    this.userService.setLeadEntry('authorizations');
    this.userService.setSelectedLead(rowDetail.authorizationId);  //rowDetail.referral_participant_id
    setTimeout(() => {
      this.router.navigate(['/home/authorizations/details/'], { state: { authorizationId: rowDetail.authorizationId } });
    }, 200);
  }

  onDataReceived(data: any[]): void {
    data.forEach((row: any) => {
      const authorized = parseFloat(row.units) || 0;
      const spent = parseFloat(row.usedUnits) || 0;
      row.usedUnits = spent.toFixed(2);
      row.remainingDollars = (authorized - spent).toFixed(2);
    });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    const availableActions = PAGE_AVAILABLE_ACTIONS[this.pageId] ?? [];
    if (availableActions.length > 0 && authConfig?.pages[this.pageId]) {
      const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
      this.actionsToBeHidden = availableActions.filter(
        action => !allowedActions.some(aa => aa.toLowerCase() === action.toLowerCase())
      );
    }
    this.isPageRestrictionLoaded = true;
  }
}
